import React from 'react';
import withView from '../../cmn/docAutomation/withView';
import SarasMsgRow from '../../../library/notifications/SarasMsgRow'
import FormWrapper from '../../../library/form/components/FormWrapper';
import FormLabel from '../../../library/form/components/FormLabel';
import FormROValue from '../../../library/form/components/FormROValue1';
import SarasTrans from '../../../library/notifications/SarasTrans';

const InvTrackHeader = (props) => {
    const { formObject, viewMessages } = props;
    
    // console.log("debug message list", viewMessages);

    return (
        <>
        {viewMessages ? <div>
            <span className='uiInlineErr'>
                {
                    Object.values(viewMessages).map((msg, index)=>(
                        <SarasMsgRow notification={msg} key={index}/>
                    ))
                }
            </span>
        </div> : null }
        <FormWrapper customWrapper="div" formObject={formObject} rowKey="" 
            wrapperClass="uiInlineErr" action={{ paramName: "container" }} >
                <span className="uiLblInLine">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "lastPaidOn" }} value="Last Paid Date" />
                </span>
                <FormROValue format="#" className="uiHighlightBlue" formObject={formObject} rowKey="" action={{ paramName: "lastPaidOn" }} />
                <span className="uiSpacerH15"></span>
                <span className="uiLblInLine">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "outstanding" }} value="Total Outstanding" />
                </span>
                <FormROValue format="#" className="uiHighlightBlue" formObject={formObject} rowKey="" action={{ paramName: "outstanding" }} />
                <span className="uiLblInLine">
                    <SarasTrans value="Credit Days" />
                </span>
                <FormROValue format="#" className="uiHighlightBlue" formObject={formObject} rowKey="" action={{ paramName: "creditDays" }} />
                
                <FormWrapper customWrapper="" formObject={formObject} rowKey="" action={{ paramName: "creditDaysUsed" }} >
                    <span> (</span><FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "creditDaysUsed" }} /> %)
                </FormWrapper>
                
                <span className="uiLblInLine">
                    <SarasTrans value="Credit Limit" />
                </span>
                <FormROValue format="#" className="uiHighlightBlue" formObject={formObject} rowKey="" action={{ paramName: "creditLimit" }} />

                <FormWrapper customWrapper="" formObject={formObject} rowKey="" action={{ paramName: "creditLimitUsed" }} >
                    <span> (</span><FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "creditLimitUsed" }} /> %)
                </FormWrapper>
        </FormWrapper>
    </>
    )
}

export default withView(InvTrackHeader, "invTrnTracker", "")